import React from 'react'

const Loading = () => {
  return (
    <div className="flex w-full h-full z-[1000] justify-center items-center absolute bg-gradient-to-br from-[#EAEAEA]/90 via-green-50/90 to-[#228B22]/20">

      {/* Loading Container */}
      <div className="relative flex flex-col justify-center items-center w-[180px] h-[180px] bg-white shadow-lg rounded-3xl border border-[#228B22]/30">
        {/* Rotating Football */}
        <div className="relative mb-3">
          <div
            className="w-14 h-14 flex items-center justify-center text-3xl animate-spin"
          >
            ⚽
          </div>
        </div>

        {/* Loading Text */}
        <div className="text-center">
          <h3 className="text-[#228B22] font-bold text-base mb-2">Loading</h3>
          <div className="flex items-center justify-center space-x-1">
            <div className="w-2 h-2 bg-[#228B22] rounded-full"></div>
            <div className="w-2 h-2 bg-[#FFD700] rounded-full"></div>
            <div className="w-2 h-2 bg-[#1E90FF] rounded-full"></div>
          </div>
          <p className="text-gray-500 text-xs mt-2 font-medium">Please wait...</p>
        </div>
      </div>
    </div>
  );
}

export default Loading
